<template>
  <v-container
    ref="container"
    class="overflow-y-auto pa-0"
  >
    <v-row
      v-for="(item,index) in items"
      :key="item.raw.codeId"
    >
      <code-item-simple-card
        :item="item"
        @pick="pick => $emit('pick', pick)"
      />
    </v-row>
  </v-container>
</template>

<script>
    import CodeItemSimpleCard from "@/components/items/code/CodeItemSimpleCard";

    export default {
        name: "CodeListItemSimpleCard",
        components: {CodeItemSimpleCard},
        props: {
            items: {
                type: Array,
                default: () => [],
            },
        },
    }
</script>

<style scoped>

</style>